import { render } from "./EditMenuItem.vue?vue&type=template&id=37bc6329"
import script from "./EditMenuItem.vue?vue&type=script&lang=js"
export * from "./EditMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wouter/Vue-apps/BRGR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__